export default __webpack_public_path__ + "static/media/IMG-20241005-WA0003.8984b94b.jpg";